import React, { useState } from 'react';
import { Button, Input } from '@lognai/synapse-design-system-v2';

export interface ChatComposerProps {
  onSubmit: (text: string) => void;
  disabled?: boolean;
  /**
   * A turn is in flight. The composer trades Send for Stop, because an answer
   * that is still arriving is the one moment a person most wants a control and
   * the only one the composer had was a greyed-out button (QA ledger ASK-004).
   */
  isStreaming?: boolean;
  onStop?: () => void;
}

export const ChatComposer: React.FC<ChatComposerProps> = ({
  onSubmit,
  disabled,
  isStreaming = false,
  onStop,
}) => {
  const [value, setValue] = useState('');
  const canStop = isStreaming && onStop !== undefined;
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        const trimmed = value.trim();
        if (!trimmed || disabled) return;
        onSubmit(trimmed);
        setValue('');
      }}
      style={{ padding: '10px 14px', borderTop: '1px solid var(--border)', display: 'flex', gap: 8 }}
    >
      {/* The field stays editable while a turn streams, so the next question can
          be typed rather than waited for. Only sending is held back. */}
      <Input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Ask LognAI…"
        disabled={disabled && !isStreaming}
        aria-label="Message"
        className="flex-1 text-sm"
      />
      {canStop ? (
        <Button type="button" variant="outline" size="sm" onClick={onStop}>
          Stop
        </Button>
      ) : (
        <Button
          type="submit"
          variant="secondary"
          size="sm"
          disabled={disabled || value.trim().length === 0}
        >
          Send
        </Button>
      )}
    </form>
  );
};
